import React from 'react';
import { Gear } from '@gravity-ui/icons';
import CameraHealthBadge from '../CameraHealthBadge/CameraHealthBadge';
import CameraNumber from '../CameraNumber/CameraNumber';
import { resolveCameraCardPreviewUrl } from '../../utils/cameraPreview';
import './CameraCard.css';

/**
 * Карточка камеры на страницах «Кадры» и «Оборудование».
 * Статус-бейдж перекрывает превью в левом верхнем углу. Диагностика и
 * управление командами доступны только в админке (AdminPage).
 * Превью — свежий последний кадр; original камеры показывается, пока кадр грузится.
 *
 * ТЗ №26: onOpenAdmin передаётся только администратору — без него кнопки
 * «Настройки камеры» в разметке нет вовсе.
 */
const CameraCard = ({ camera, lastFrame, onOpen, onOpenAdmin }) => {
  const imgUrl = resolveCameraCardPreviewUrl(camera, lastFrame);

  return (
    <div className="cam-card" onClick={() => onOpen(camera)}>
      <div className="cam-card-image">
        {imgUrl ? (
          <img src={imgUrl} alt={camera.name} />
        ) : (
          <div className="cam-card-image-placeholder">Превью недоступно</div>
        )}

        <div className="cam-card-badge">
          <CameraHealthBadge camera={camera} compact />
        </div>

        {onOpenAdmin && (
          <button
            type="button"
            className="cam-card-admin-btn"
            title="Настройки камеры"
            aria-label="Настройки камеры"
            onClick={(event) => {
              event.stopPropagation();
              onOpenAdmin(camera);
            }}
          >
            <Gear width={16} height={16} />
          </button>
        )}
      </div>

      <div className="cam-card-name" title={camera.name}>
        {camera.name}
        <CameraNumber id={camera.id} />
      </div>
    </div>
  );
};

export default CameraCard;
